import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { Observable, of } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MenuService, RenderableMenu } from '@rocksoft/cdk';
import { BrandComponent, MenusComponent } from '@rocksoft/shared';

@Component({
  selector: 'era-default',
  templateUrl: './default.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent, BrandComponent, MenusComponent, RouterOutlet, AsyncPipe],
})
export class DefaultComponent {
  private readonly menuService = inject(MenuService);

  public readonly menus$: Observable<RenderableMenu[]>;

  public collapsed = true;
  constructor() {
    this.menus$ = of(this.menuService.menu);
  }
}
